export const TABLE_LIMIT = 20;

export const CUSTOMERS_STATUSES = {
  0: "New",
  1: "Onboarded",
  2: "Active",
  255: "Blocked",
};

export const DIRECTIONS = {
  inbound: "Inbound",
  outbound: "Outbound",
};

export const SERVICE_TYPES = {
  TTS: "tts",
  STT: "stt",
  LLM: "llm",
};

export const LEVELS = [
  { label: "verbose", value: "verbose" },
  { label: "debug", value: "debug" },
  { label: "log", value: "log" },
  { label: "warn", value: "warn" },
  { label: "error", value: "error" },
  { label: "fatal", value: "fatal" },
];

export const SUBSCRIPTION_STATUSES = {
  0: "INACTIVE",
  1: "ACTIVE",
  2: "TRIAL",
  3: "CANCELLED",
  4: "PAST_DUE",
  "-1": "NONE",
};

export const INTERACTION_STATUSES = {
  0: "New",
  1: "Ringing",
  2: "Conversation",
  50: "Busy",
  51: "NoAnswer",
  52: "Machine",
  100: "Finished",
  254: "Rejected",
  255: "Error",
};
